import countriesByAbbreviation from 'country-json/src/country-by-abbreviation.json';
import { cloneDeep, sortBy } from 'lodash';

let countriesByAbbreviationCopy = cloneDeep(countriesByAbbreviation)

countriesByAbbreviationCopy.push(
    {
    "abbreviation": "AX",
    "country": "Åland Islands"
    },
    {
    "abbreviation": "CW",
    "country": "Curaçao"
    },
    {
    "abbreviation": "SX",
    "country": "Sint Maarten"
    },
    {
    "abbreviation": "BQ",
    "country": "Caribbean Netherlands"
    },
    {
    "abbreviation": "XK",
    "country": "Kosovo"
    },
    {
    "abbreviation": "TW",
    "country": "Taiwan"
    },
    {
    "country": "Unknown",
    "abbreviation": "ZZ"     
});

countriesByAbbreviationCopy = countriesByAbbreviationCopy.map(obj => {
    if (obj.abbreviation === 'GB') {
        return {...obj, country: 'United Kingdom'};
    }
    
    if(obj.abbreviation == 'UK')
        return false;

    return obj;
});

countriesByAbbreviationCopy = sortBy(countriesByAbbreviationCopy, 'country');

export default countriesByAbbreviationCopy;